module.exports = __webpack_public_path__ + "static/img/materialsInfo19.83b4ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo19.png
// module id = gNRe
// module chunks = 2